module.exports = __webpack_public_path__ + "static/media/Produtos5.25769b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos5.png
// module id = 2004
// module chunks = 0